module.exports = __webpack_public_path__ + "media/images/athletes/931-f3406716d7b20619176d321dcd9e1ef3.png";